module.exports = __webpack_public_path__ + "6748db3d05fb434014f4b0c1e43f5546.svg";